import { PRIVATE_API_ROUTES } from '@/constants/api.constants';
import { getFlatListApiCall } from './utils';

export const flatListEmploymentTypes = getFlatListApiCall({
  route: PRIVATE_API_ROUTES.employmentTypes,
});
